import { BaseEntity } from 'yt-ng-framework';

export class Sprema extends BaseEntity {
    constructor(){
        super();
    }
    Naziv: string=null;
    Sifra: string=null;
    Nivo: string=null;
    Opis: string=null;
    Ekvivalencija: string=null;

    Deserialize(input: any) {
        this.ID = input.ID;
        this.Naziv = input.Naziv;
        this.Sifra = input.Sifra;
        this.Nivo = input.Nivo;
        this.Opis = input.Opis;
        this.Ekvivalencija = input.Ekvivalencija;
        return this;
    }

    Serialize(input: Sprema) {
        return input;
    }
}
